export const tabs = [
  {
    label: "设备列表",
    value: "DEVICE_LIST"
  },
  {
    label: "采集数据",
    value: "COLLECT_DATA"
  }
]

export const deviceColumns = [
  {
    label: "设备ID",
    value: "sn"
  },
  // {
  //   label: "设备型号",
  //   value: "deviceModel"
  // },
  {
    label: "指标",
    value: "metricNumber"
  }
  // {
  //   label: "设备状态",
  //   value: "deviceState"
  // }
]

export const logColumns = [
  {
    label: "设备ID",
    value: "sn"
  },
  {
    label: "指标ID",
    value: "metricId"
  },
  {
    label: "指标名称",
    value: "metricName"
  },
  {
    label: "采集时间",
    value: "createdDate"
  },
  {
    label: "采集值",
    value: "value"
  },
  {
    label: "单位",
    value: "unit"
  }
]
